<template>
  <label class="radio-box-wrapper" :class="classNames" :style="sizeStyle">
    <input :name="name" :value="value" class="input" type="radio" @click.stop="onChecked" />
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'VRadioBox',
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    onChecked: {
      type: Function,
      required: true
    },
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classNames() {
      return { active: this.value === this.state, disabled: this.disabled }
    },
    sizeStyle() {
      return { '--widthSize': this.width, '--heightSize': this.height }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.radio-box-wrapper {
  display: block;
  position: relative;
  padding-left: 29px;
  padding-left: calc((var(--widthSize) + 5) * 1px);
  letter-spacing: -0.3px;
  width: 24px;
  height: 24px;
  width: 100%;
  height: calc(var(--heightSize) * 1px);
  font-size: 18px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 1px;

  box-sizing: border-box;

  cursor: pointer;

  &:after {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    width: 24px;
    height: 24px;
    width: calc(var(--widthSize) * 1px);
    height: calc(var(--heightSize) * 1px);
    display: block;
    border-radius: 2px;
    background-position: 0 -24px;
    background-position: 0 calc((var(--heightSize) + 1) * -1px);
    z-index: 1;
    background-image: url('~@/assets/images/sp-input.png');
    background-size: 72px auto;
    background-size: calc((var(--heightSize) + 1) * 3px) auto;
  }
}

.active {
  &:after {
    background-position: -24px -24px;
    background-position: calc((var(--widthSize) + 1) * -1px) calc((var(--heightSize) + 1) * -1px);
  }
}

.disabled {
  // background-position: calc((var(--heightSize) + 1) * -1px) calc((var(--heightSize) + 1) * -1px);
  &:after {
    background-position: calc((var(--heightSize) + 1) * -2px) calc((var(--heightSize) + 1) * -1px);
  }
}
</style>